{
  "pt": {
    "upload": {
      "labels": {
        "cancelUpload": "Cancelar carregamento",
        "cancelUploadConfirmation": "Tem a certeza de que pretende cancelar esta transferência?",
        "chooseCategory": "Clique para selecionar primeiro uma categoria",
        "defaultMessage": "Adicionar ou largar ficheiros",
        "fallbackMessage": "O seu browser não suporta o carregamento de ficheiros por arrastar e largar.",
        "fallbackText": "Utilize o formulário de recurso abaixo para carregar os seus ficheiros como antigamente.",
        "fileTooBig": "O ficheiro é demasiado grande ({filesize} MB). Tamanho máximo do ficheiro: {maxFilesize} MB.",
        "invalidFileType": "Não é possível carregar ficheiros deste tipo.",
        "maxFilesExceeded": "Não é possível carregar mais ficheiros.",
        "noExtension": "O ficheiro não tem extensão",
        "rejectedFiles": "Os seguintes ficheiros foram rejeitados:",
        "removeFile": "Remover ficheiro",
        "responseError": "O servidor respondeu com o código {statusCode}.",
        "uploadConfirmation": "Carregamento confirmado",
        "uploadError": "Erro de carregamento",
        "warningMaxFileSize": "Até {max_files_size} cada"
      }
    }
  }
}